export default __webpack_public_path__ + "static/media/our-team-5.9fd68640.jpg";